// Super-admin menu and pages.
// Items with a `name` appear in the sidebar; items without one are reachable pages (add / edit / view).

import Dashboard from "./views/Dashboard.js";
import Profile from "./views/Profile.js";
import Login from "./views/Login.js";
import ForgotPassword from "./views/forgotPassword.js";
import ForgotPasswordOtp from "./views/Otp.js";
import ResetPasswordOtp from "./views/newPassword.js";
import ChangePassword from "./views/ChangePassword.js";

import UserIndex from "./views/User/Index.js";
import UserAdd from "./views/User/Add.js";
import UserEdit from "./views/User/Edit.js";
import UserOne from "./views/User/ViewOne.js";

import SaleType from "./views/SaleType/Index";
import SaleTypeAdd from "./views/SaleType/Add";
import SaleTypeEdit from "./views/SaleType/Edit";

import SaleCategory from "./views/SaleCategory/Index";
import SaleCategoryAdd from "./views/SaleCategory/Add";
import SaleCategoryEdit from "./views/SaleCategory/Edit";

import Category from "./views/Category/Index.js";
import CategoryAdd from "./views/Category/Add.js";
import CategoryEdit from "./views/Category/Edit.js";
import CategoryView from "./views/Category/View.js";
import SubCategory from "./views/Subcategory/Index.js";
import SubCategoryAdd from "./views/Subcategory/Add.js";
import SubCategoryEdit from "./views/Subcategory/Edit.js";
import SubCategoryView from "./views/Subcategory/View.js";

import DefaultTemplate from "./views/DefaultTemplate/Index";
import DefaultTemplateAdd from "./views/DefaultTemplate/Add";
import DefaultTemplateEdit from "./views/DefaultTemplate/Edit";
import ManageField from "./views/DefaultManageField/Index";

import Pricing from "./views/Pricing/Index.js";
import PricingAdd from "./views/Pricing/Add.js";
import PricingEdit from "./views/Pricing/Edit.js";
import PricingView from "./views/Pricing/View.js";
import PlanFeatures from "./views/PlanFeatures/Index.js";
import PlanFeaturesAdd from "./views/PlanFeatures/Add.js";
import PlanFeaturesEdit from "./views/PlanFeatures/Edit.js";
import SaleFees from "./views/SaleFees/Index.js";
// Special invoices to companies (marketing etc.)
import Invoices from "./views/Invoices/Index.js";
import InvoiceEdit from "./views/Invoices/Edit.js";
import AuditLog from "./views/AuditLog/Index.js";

// Master email templates (what the system sends; also copied to companies)
import EmailTemplateView from "./views/Email/Index.js";
import EmailTemplateAdd from "./views/Email/Add.js";
import EmailTemplateEdit from "./views/Email/Edit.js";
import EmailTemplateViewOne from "./views/Email/ViewOne.js";

// Company copies of email templates are no longer used (companies set a signature, reply-to
// and logo in their own Email Settings instead), so these pages are hidden.
// import CompanyEmailTemplate from "./views/EmailTemplate/Index";
// import CompanyEmailTemplateAdd from "./views/EmailTemplate/Add";
// import CompanyEmailTemplateEdit from "./views/EmailTemplate/Edit";
// import CompanyEmailTemplateView from "./views/EmailTemplate/ViewOne.js";

// Bidder text-message wording (super admin only)
import SmsTemplates from "./views/Sms/Index.js";


const admin = (path, component, extra = {}) => ({ path, component, layout: "/admin", ...extra });

var routes = [
  // ─── Sidebar menu ───
  admin("/index", <Dashboard />, { name: "Dashboard" }),
  // activeFor: related pages that keep this menu item highlighted
  admin("/user", <UserIndex />, { name: "Companies", activeFor: ["/change-password"] }),
  {
    path: "/sale-type",
    name: "Catalog Setup",
    component: <SaleType />,
    layout: "/admin",
    subMenu: [
      admin("/sale-type", <SaleType />, { name: "Sale Types", activeFor: ["/sale-category"] }),
      admin("/category", <Category />, { name: "Categories", activeFor: ["/sub-category"] }),
      admin("/default-template", <DefaultTemplate />, { name: "Default Templates", activeFor: ["/template"] }),
    ],
  },
  {
    path: "/pricing",
    name: "Plans",
    component: <Pricing />,
    layout: "/admin",
    subMenu: [
      admin("/pricing", <Pricing />, { name: "Manage Plans" }),
      admin("/plan-features", <PlanFeatures />, { name: "Plan Features" }),
      admin("/sale-fees", <SaleFees />, { name: "Sale Fees" }),
    ],
  },
  admin("/invoices", <Invoices />, { name: "Invoices" }),
  admin("/email", <EmailTemplateView />, { name: "Email Templates" }),
  admin("/sms-templates", <SmsTemplates />, { name: "SMS Templates" }),
  admin("/audit-log", <AuditLog />, { name: "Audit Log" }),

  // ─── Pages (not in the menu) ───
  admin("/profile", <Profile />),
  admin("/change-password", <ChangePassword />),
  admin("/invoices/edit", <InvoiceEdit />),

  admin("/user/add", <UserAdd />),
  admin("/user/edit", <UserEdit />),
  admin("/user/view", <UserOne />),

  admin("/sale-type/add", <SaleTypeAdd />),
  admin("/sale-type/edit", <SaleTypeEdit />),
  admin("/sale-category", <SaleCategory />),
  admin("/sale-category/add", <SaleCategoryAdd />),
  admin("/sale-category/edit", <SaleCategoryEdit />),

  admin("/category/add", <CategoryAdd />),
  admin("/category/edit", <CategoryEdit />),
  admin("/category/view", <CategoryView />),
  admin("/category/sub-categories", <SubCategory />),
  admin("/sub-category/add", <SubCategoryAdd />),
  admin("/category/sub-category/edit", <SubCategoryEdit />),
  admin("/category/sub-category/view", <SubCategoryView />),

  admin("/default-template/add", <DefaultTemplateAdd />),
  admin("/default-template/edit", <DefaultTemplateEdit />),
  admin("/template/manage-field", <ManageField />),

  admin("/pricing/add", <PricingAdd />),
  admin("/pricing/edit", <PricingEdit />),
  admin("/pricing/view", <PricingView />),
  admin("/plan-features/add", <PlanFeaturesAdd />),
  admin("/plan-features/edit", <PlanFeaturesEdit />),

  admin("/email/add", <EmailTemplateAdd />),
  admin("/email/edit", <EmailTemplateEdit />),
  admin("/email/view", <EmailTemplateViewOne />),

  // admin("/email-template", <CompanyEmailTemplate />),
  // admin("/email-template/add", <CompanyEmailTemplateAdd />),
  // admin("/email-template/edit", <CompanyEmailTemplateEdit />),
  // admin("/email-template/view", <CompanyEmailTemplateView />),

  // ─── Sign-in pages ───
  { path: "/login", component: <Login />, layout: "/auth" },
  { path: "/forgot-password", component: <ForgotPassword />, layout: "/auth" },
  { path: "/reset-password/:id", component: <ResetPasswordOtp />, layout: "/auth" },
  { path: "/forgot-password-otp/:id", component: <ForgotPasswordOtp />, layout: "/auth" },
];

export default routes;
